const cssStyles = () => `
.FullPageSignup__signupToggle {
  color: #717171;
}

.FullPageSignup__signupToggle:focus,
.FullPageSignup__signupToggle:hover  {
  color: #8a8a8a;
}

`;

export default cssStyles;
